export default __webpack_public_path__ + "static/media/timer.026411e9.svg";